import * as React from "react";
import { useEffect, useState } from "react";

const ExpandedSectionContext = React.createContext<any>(null);

type ExpandedSectionProviderProps = {
  defaultSection?: string | number;
  children?: React.ReactNode;
};

export function ExpandedSectionProvider({
  defaultSection = "",
  children,
}: ExpandedSectionProviderProps) {
  const [editSectionDetails, setEditSectionDetails] = useState<boolean>(false);
  const [expandedSection, setExpandedSection] = useState<string | number>(
    defaultSection
  );

  const handleSectionClick =
    (selectedSection: string, multipleExpand: boolean = false) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedSection(
        isExpanded ? selectedSection : multipleExpand ? selectedSection : ""
      );
    };

  useEffect(() => {
    if (!expandedSection) {
      setEditSectionDetails(false);
    }
  }, [expandedSection]);

  return (
    <ExpandedSectionContext.Provider
      value={{
        editSectionDetails,
        setEditSectionDetails,
        expandedSection,
        handleSectionClick,
      }}
    >
      {children}
    </ExpandedSectionContext.Provider>
  );
}

export default function useExpandedSection() {
  const expandedSectionContext = React.useContext(ExpandedSectionContext);
  if (!expandedSectionContext) {
    throw new Error(
      `useExpandedSection must be used within a ExpandedSectionProvider`
    );
  }
  const {
    editSectionDetails,
    setEditSectionDetails,
    expandedSection,
    handleSectionClick,
  } = expandedSectionContext;
  return {
    editSectionDetails,
    setEditSectionDetails,
    expandedSection,
    handleSectionClick,
  };
}
